import React from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Table,
  UncontrolledAlert
} from "reactstrap";

import GenericHeader from "components/Headers/GenericHeader.js";


const PAGE_SIZE = 10;

const emptyRecipient = {
  Name: "",
  DisplayName: "",
  Nickname: "",
  Electricity: false,
  Gas: false,
  Supplier: true,
  Maintainer: false,
  Active: true,
  PhotoElectricity: " ",
  PhotoGas: " "
};

const emptyCategory = {
  path: "",
  parentPath: "",
  value: "",
  label: "",
  active: true
};

const recipientFormLabels = {
  Electricity: "Ηλεκτρική ενέργεια",
  Gas: "Φυσικό αέριο",
  Supplier: "Προμηθευτής",
  Maintainer: "Διαχειριστής",
  Active: "Ενεργός"
};

const responseDeadlineFields = [
  { name: "ElectricitySupplierDuration", label: "Ηλεκτρική Ενέργεια / Προμηθευτής" },
  { name: "ElectricityNetworkOperatorDuration", label: "Ηλεκτρική Ενέργεια / Διαχειριστής Δικτύου" },
  { name: "GasSupplierDuration", label: "Φυσικό Αέριο / Προμηθευτής" },
  { name: "GasNetworkOperatorDuration", label: "Φυσικό Αέριο / Διαχειριστής Δικτύου" }
];


class RecipientCategoryManagement extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: null,
      recipients: [],
      categoryActions: [],
      selectedCategoryActionId: "",
      recipientForm: { ...emptyRecipient },
      recipientId: null,
      showRecipientForm: false,
      recipientSearch: "",
      recipientStatusFilter: "all",
      recipientPage: 1,
      categoryForm: { ...emptyCategory },
      showCategoryForm: false,
      categorySearch: "",
      categoryStatusFilter: "all",
      categoryPage: 1,
      responseDeadlines: {
        ElectricitySupplierDuration: "",
        ElectricityNetworkOperatorDuration: "",
        GasSupplierDuration: "",
        GasNetworkOperatorDuration: ""
      },
      responseDeadlineMessage: "",
      responseDeadlineError: "",
      responseDeadlineSaving: false,
      error: "",
      success: "",
      isLoading: false
    };
  }

  getHeaders() {
    return new Headers({
      "Authorization": "Bearer " + localStorage.getItem("token"),
      "Content-Type": "application/json"
    });
  }

  componentDidMount() {
    this.loadCurrentUser();
  }

  loadCurrentUser() {
    fetch(process.env.REACT_APP_API_LINK + "/api/auth/user/", {
      method: "get",
      headers: this.getHeaders()
    })
      .then(res => res.json())
      .then(user => {
        if (user.PersonRole !== "Admin") {
          this.props.history.goBack();
          return;
        }
        this.setState({ user }, () => {
          this.loadRecipients();
          this.loadCategoryActions();
          this.loadResponseDeadlines();
        });
      })
      .catch(() => this.setState({ error: "Αδυναμία φόρτωσης χρήστη." }));
  }

  loadRecipients() {
    this.setState({ isLoading: true });
    fetch(process.env.REACT_APP_API_LINK + "/api/admin_management/recipients/", {
      method: "get",
      headers: this.getHeaders()
    })
      .then(res => res.json())
      .then(recipients => this.setState({ recipients, isLoading: false }))
      .catch(() => this.setState({ error: "Αδυναμία φόρτωσης παραληπτών.", isLoading: false }));
  }

  loadCategoryActions() {
    fetch(process.env.REACT_APP_API_LINK + "/api/admin_management/category_actions/", {
      method: "get",
      headers: this.getHeaders()
    })
      .then(res => res.json())
      .then(categoryActions => {
        this.setState({
          categoryActions,
          selectedCategoryActionId: categoryActions[0] ? String(categoryActions[0].Id) : ""
        });
      })
      .catch(() => this.setState({ error: "Αδυναμία φόρτωσης κατηγοριών." }));
  }

  getResponseDeadlineState(result) {
    const fallbackDeadline = result.Duration || 10;
    const responseDeadlines = {};
    responseDeadlineFields.forEach(field => {
      responseDeadlines[field.name] = result[field.name] || fallbackDeadline;
    });
    return responseDeadlines;
  }

  loadResponseDeadlines() {
    fetch(process.env.REACT_APP_API_LINK + "/api/workflows/response_deadline/", {
      method: "get",
      headers: this.getHeaders()
    })
      .then(res => {
        if (!res.ok) {
          throw new Error();
        }
        return res.json();
      })
      .then(result => {
        this.setState({
          responseDeadlines: this.getResponseDeadlineState(result),
          responseDeadlineError: ""
        });
      })
      .catch(() => this.setState({
        responseDeadlineError: "Δεν ήταν δυνατή η ανάκτηση των προθεσμιών απάντησης.",
        responseDeadlineMessage: ""
      }));
  }

  updateResponseDeadlineField(field, value) {
    this.setState(prevState => ({
      responseDeadlines: {
        ...prevState.responseDeadlines,
        [field]: value
      },
      responseDeadlineMessage: "",
      responseDeadlineError: ""
    }));
  }

  saveResponseDeadline() {
    const payload = {};

    for (let i = 0; i < responseDeadlineFields.length; i++) {
      const field = responseDeadlineFields[i];
      const duration = parseInt(this.state.responseDeadlines[field.name], 10);

      if (isNaN(duration) || duration < 1) {
        this.setState({
          responseDeadlineError: "Η προθεσμία πρέπει να είναι θετικός αριθμός εργάσιμων ημερών.",
          responseDeadlineMessage: ""
        });
        return;
      }

      payload[field.name] = duration;
    }

    this.setState({ responseDeadlineSaving: true });

    fetch(process.env.REACT_APP_API_LINK + "/api/workflows/response_deadline/", {
      method: "PUT",
      headers: this.getHeaders(),
      body: JSON.stringify(payload)
    })
      .then(res => {
        if (!res.ok) {
          throw new Error();
        }
        return res.json();
      })
      .then(result => {
        this.setState({
          responseDeadlines: this.getResponseDeadlineState(result),
          responseDeadlineMessage: "Οι προθεσμίες απάντησης ενημερώθηκαν επιτυχώς.",
          responseDeadlineError: "",
          responseDeadlineSaving: false
        });
      })
      .catch(() => this.setState({
        responseDeadlineError: "Δεν ήταν δυνατή η ενημέρωση των προθεσμιών απάντησης.",
        responseDeadlineMessage: "",
        responseDeadlineSaving: false
      }));
  }

  updateRecipientField(field, value) {
    this.setState(prevState => ({
      recipientForm: {
        ...prevState.recipientForm,
        [field]: value
      }
    }));
  }

  showNewRecipientForm() {
    this.setState({
      recipientForm: { ...emptyRecipient },
      recipientId: null,
      showRecipientForm: true,
      error: "",
      success: ""
    });
  }

  resetRecipientForm() {
    this.setState({
      recipientForm: { ...emptyRecipient },
      recipientId: null,
      showRecipientForm: false
    });
  }

  editRecipient(recipient) {
    this.setState({
      recipientId: recipient.Id,
      showRecipientForm: true,
      error: "",
      success: "",
      recipientForm: {
        Name: recipient.Name || "",
        DisplayName: recipient.DisplayName || recipient.Name || "",
        Nickname: recipient.Nickname || "",
        Electricity: !!recipient.Electricity,
        Gas: !!recipient.Gas,
        Supplier: !!recipient.Supplier,
        Maintainer: !!recipient.Maintainer,
        Active: !!recipient.Active,
        PhotoElectricity: recipient.PhotoElectricity || " ",
        PhotoGas: recipient.PhotoGas || " "
      }
    });
  }

  saveRecipient() {
    const form = this.state.recipientForm;
    if (!form.Name.trim()) {
      this.setState({ error: "Συμπληρώστε επωνυμία παραλήπτη.", success: "" });
      return;
    }

    const payload = {
      ...form,
      Name: form.Name.trim(),
      DisplayName: form.DisplayName.trim() || form.Name.trim(),
      Nickname: form.Nickname.trim(),
      PhotoElectricity: form.PhotoElectricity || " ",
      PhotoGas: form.PhotoGas || " "
    };

    const method = this.state.recipientId ? "PUT" : "POST";
    const url = this.state.recipientId
      ? process.env.REACT_APP_API_LINK + "/api/admin_management/recipients/" + this.state.recipientId + "/"
      : process.env.REACT_APP_API_LINK + "/api/admin_management/recipients/";

    fetch(url, {
      method,
      headers: this.getHeaders(),
      body: JSON.stringify(payload)
    })
      .then(res => {
        if (!res.ok) {
          throw new Error();
        }
        return res.json();
      })
      .then(() => {
        this.setState({
          success: this.state.recipientId ? "Οι αλλαγές στον παραλήπτη αποθηκεύτηκαν." : "Ο παραλήπτης δημιουργήθηκε.",
          error: "",
          recipientPage: 1
        });
        this.resetRecipientForm();
        this.loadRecipients();
      })
      .catch(() => this.setState({ error: "Αδυναμία αποθήκευσης παραλήπτη.", success: "" }));
  }

  toggleRecipientActive(recipient) {
    fetch(process.env.REACT_APP_API_LINK + "/api/admin_management/recipients/" + recipient.Id + "/active/", {
      method: "PUT",
      headers: this.getHeaders(),
      body: JSON.stringify({ Active: !recipient.Active })
    })
      .then(res => {
        if (!res.ok) {
          throw new Error();
        }
        return res.json();
      })
      .then(() => {
        this.setState({ success: "Η κατάσταση παραλήπτη ενημερώθηκε.", error: "" });
        this.loadRecipients();
      })
      .catch(() => this.setState({ error: "Αδυναμία ενημέρωσης κατάστασης παραλήπτη.", success: "" }));
  }

  getSelectedCategoryAction() {
    return this.state.categoryActions.find(action => String(action.Id) === String(this.state.selectedCategoryActionId));
  }

  getCategoryRows(nodes, path = [], parentLabel = "") {
    let rows = [];
    (nodes || []).forEach((node, index) => {
      const currentPath = path.concat(index);
      const label = node.label || node.value || "";
      const labelPath = parentLabel ? parentLabel + " / " + label : label;
      rows.push({ node, path: currentPath, labelPath });
      rows = rows.concat(this.getCategoryRows(node.children || [], currentPath, labelPath));
    });
    return rows;
  }

  cloneTarget(target) {
    return JSON.parse(JSON.stringify(target || []));
  }

  getNodeAtPath(target, path) {
    let current = null;
    let list = target;
    path.forEach(index => {
      current = list[index];
      list = current.children || [];
    });
    return current;
  }

  saveCategoryTarget(target, message) {
    const action = this.getSelectedCategoryAction();
    if (!action) {
      return;
    }

    fetch(process.env.REACT_APP_API_LINK + "/api/admin_management/category_actions/" + action.Id + "/target/", {
      method: "PUT",
      headers: this.getHeaders(),
      body: JSON.stringify({ Target: target })
    })
      .then(res => {
        if (!res.ok) {
          throw new Error();
        }
        return res.json();
      })
      .then(updatedAction => {
        this.setState(prevState => ({
          categoryActions: prevState.categoryActions.map(item =>
            String(item.Id) === String(updatedAction.Id) ? updatedAction : item
          ),
          success: message,
          error: "",
          categoryForm: { ...emptyCategory },
          showCategoryForm: false,
          categoryPage: 1
        }));
      })
      .catch(() => this.setState({ error: "Αδυναμία αποθήκευσης κατηγοριών.", success: "" }));
  }

  updateCategoryField(field, value) {
    this.setState(prevState => ({
      categoryForm: {
        ...prevState.categoryForm,
        [field]: value
      }
    }));
  }

  showNewCategoryForm() {
    this.setState({
      categoryForm: { ...emptyCategory },
      showCategoryForm: true,
      error: "",
      success: ""
    });
  }

  editCategory(row) {
    this.setState({
      showCategoryForm: true,
      error: "",
      success: "",
      categoryForm: {
        path: JSON.stringify(row.path),
        parentPath: "",
        value: row.node.value || "",
        label: row.node.label || row.node.value || "",
        active: row.node.active !== false
      }
    });
  }

  resetCategoryForm() {
    this.setState({
      categoryForm: { ...emptyCategory },
      showCategoryForm: false
    });
  }

  saveCategory() {
    const action = this.getSelectedCategoryAction();
    if (!action || !this.state.categoryForm.value.trim()) {
      this.setState({ error: "Συμπληρώστε τιμή κατηγορίας.", success: "" });
      return;
    }

    const target = this.cloneTarget(action.Target);
    const categoryName = this.state.categoryForm.value.trim();
    const categoryNode = {
      value: categoryName,
      label: categoryName,
      active: this.state.categoryForm.active,
      children: []
    };

    if (this.state.categoryForm.path) {
      const node = this.getNodeAtPath(target, JSON.parse(this.state.categoryForm.path));
      node.value = categoryNode.value;
      node.label = categoryNode.label;
      node.active = categoryNode.active;
    } else {
      target.push(categoryNode);
    }

    this.saveCategoryTarget(target, this.state.categoryForm.path ? "Οι αλλαγές στην κατηγορία αποθηκεύτηκαν." : "Η κατηγορία δημιουργήθηκε.");
  }

  toggleCategoryActive(row) {
    const action = this.getSelectedCategoryAction();
    if (!action) {
      return;
    }

    const target = this.cloneTarget(action.Target);
    const node = this.getNodeAtPath(target, row.path);
    node.active = node.active === false;
    this.saveCategoryTarget(target, "Η κατάσταση κατηγορίας ενημερώθηκε.");
  }

  setRecipientFilter(field, value) {
    this.setState({ [field]: value, recipientPage: 1 });
  }

  setCategoryFilter(field, value) {
    this.setState({ [field]: value, categoryPage: 1 });
  }

  getFilteredRecipients() {
    const search = this.state.recipientSearch.trim().toLowerCase();
    return this.state.recipients.filter(recipient => {
      if (this.state.recipientStatusFilter === "active" && !recipient.Active) {
        return false;
      }
      if (this.state.recipientStatusFilter === "inactive" && recipient.Active) {
        return false;
      }
      if (!search) {
        return true;
      }

      return [recipient.Name, recipient.DisplayName]
        .some(value => (value || "").toLowerCase().includes(search));
    });
  }

  getFilteredCategoryRows(rows) {
    const search = this.state.categorySearch.trim().toLowerCase();
    return rows.filter(row => {
      const isActive = row.node.active !== false;
      if (this.state.categoryStatusFilter === "active" && !isActive) {
        return false;
      }
      if (this.state.categoryStatusFilter === "inactive" && isActive) {
        return false;
      }
      if (!search) {
        return true;
      }

      return [row.labelPath, row.node.value, row.node.label]
        .some(value => (value || "").toLowerCase().includes(search));
    });
  }

  getPageItems(items, page) {
    const start = (page - 1) * PAGE_SIZE;
    return items.slice(start, start + PAGE_SIZE);
  }

  getSafePage(page, totalItems) {
    const totalPages = Math.max(1, Math.ceil(totalItems / PAGE_SIZE));
    return Math.min(page, totalPages);
  }

  renderPagination(totalItems, page, onPageChange) {
    const totalPages = Math.max(1, Math.ceil(totalItems / PAGE_SIZE));
    if (totalPages <= 1) {
      return null;
    }

    const start = (page - 1) * PAGE_SIZE + 1;
    const end = Math.min(page * PAGE_SIZE, totalItems);
    return (
      <Row className="align-items-center mt-3">
        <Col md="6" className="text-muted">
          Εμφάνιση {start}-{end} από {totalItems}
        </Col>
        <Col md="6" className="text-right">
          <Button size="sm" color="secondary" disabled={page === 1} onClick={() => onPageChange(page - 1)}>
            Προηγούμενη
          </Button>
          <span className="mx-3">Σελίδα {page} από {totalPages}</span>
          <Button size="sm" color="secondary" disabled={page === totalPages} onClick={() => onPageChange(page + 1)}>
            Επόμενη
          </Button>
        </Col>
      </Row>
    );
  }

  getEnergyText(item) {
    const values = [];
    if (item.Electricity) {
      values.push("Ηλεκτρική ενέργεια");
    }
    if (item.Gas) {
      values.push("Φυσικό αέριο");
    }
    return values.join(", ") || "-";
  }

  getRoleText(item) {
    const values = [];
    if (item.Supplier) {
      values.push("Προμηθευτής");
    }
    if (item.Maintainer) {
      values.push("Διαχειριστής");
    }
    return values.join(", ") || "-";
  }

  renderRecipientForm() {
    if (!this.state.showRecipientForm) {
      return null;
    }

    const form = this.state.recipientForm;
    const isEdit = !!this.state.recipientId;
    return (
      <div className="border rounded p-3 mb-4">
        <h4 className="mb-3">{isEdit ? "Επεξεργασία παραλήπτη" : "Νέος παραλήπτης"}</h4>
        <Form onSubmit={e => e.preventDefault()}>
          <Row>
            <Col lg="6">
              <FormGroup>
                <Label>Επωνυμία</Label>
                <Input value={form.Name} onChange={e => this.updateRecipientField("Name", e.target.value)} />
              </FormGroup>
            </Col>
            <Col lg="6">
              <FormGroup>
                <Label>Εμφανιζόμενη επωνυμία</Label>
                <Input value={form.DisplayName} onChange={e => this.updateRecipientField("DisplayName", e.target.value)} />
              </FormGroup>
            </Col>
          </Row>
          <Row style={{paddingLeft: `20px`}}>
            {["Electricity", "Gas", "Supplier", "Maintainer", "Active"].map(field => (
              <Col lg="2" md="4" key={field}>
                <Label check className="mb-3">
                  <Input
                    type="checkbox"
                    checked={form[field]}
                    onChange={e => this.updateRecipientField(field, e.target.checked)}
                  />{" "}
                  {recipientFormLabels[field]}
                </Label>
              </Col>
            ))}
          </Row>
          <Button color="primary" className="mr-2" onClick={() => this.saveRecipient()}>
            {isEdit ? "Αποθήκευση αλλαγών" : "Δημιουργία παραλήπτη"}
          </Button>
          <Button color="secondary" onClick={() => this.resetRecipientForm()}>
            Ακύρωση
          </Button>
        </Form>
      </div>
    );
  }

  renderRecipients() {
    const filteredRecipients = this.getFilteredRecipients();
    const page = this.getSafePage(this.state.recipientPage, filteredRecipients.length);
    const recipients = this.getPageItems(filteredRecipients, page);

    return (
      <Card>
        <CardHeader>
          <Row className="align-items-center">
            <Col>
              <h3 className="mb-0">Παραλήπτες</h3>
            </Col>
            <Col className="text-right">
              <Button color="primary" onClick={() => this.showNewRecipientForm()}>
                Προσθήκη παραλήπτη
              </Button>
            </Col>
          </Row>
        </CardHeader>
        <CardBody>
          <h4 className="mb-3">Φίλτρα παραληπτών</h4>
          <Row className="mb-4">
            <Col lg="6">
              <FormGroup>
                <Label>Αναζήτηση</Label>
                <Input
                  value={this.state.recipientSearch}
                  placeholder="Επωνυμία ή εμφανιζόμενη επωνυμία"
                  onChange={e => this.setRecipientFilter("recipientSearch", e.target.value)}
                />
              </FormGroup>
            </Col>
            <Col lg="3">
              <FormGroup>
                <Label>Κατάσταση</Label>
                <Input
                  type="select"
                  value={this.state.recipientStatusFilter}
                  onChange={e => this.setRecipientFilter("recipientStatusFilter", e.target.value)}
                >
                  <option value="all">Όλοι</option>
                  <option value="active">Ενεργοί</option>
                  <option value="inactive">Ανενεργοί</option>
                </Input>
              </FormGroup>
            </Col>
          </Row>

          {this.renderRecipientForm()}

          <Table responsive>
            <thead>
              <tr>
                <th>Επωνυμία</th>
                <th>Εμφάνιση</th>
                <th>Προϊόν</th>
                <th>Ρόλος</th>
                <th>Κατάσταση</th>
                <th className="text-right">Ενέργειες</th>
              </tr>
            </thead>
            <tbody>
              {recipients.length === 0 &&
                <tr>
                  <td colSpan="6" className="text-center text-muted">Δεν βρέθηκαν παραλήπτες.</td>
                </tr>
              }
              {recipients.map(recipient => (
                <tr key={recipient.Id}>
                  <td>{recipient.Name}</td>
                  <td>{recipient.DisplayName || "-"}</td>
                  <td>{this.getEnergyText(recipient)}</td>
                  <td>{this.getRoleText(recipient)}</td>
                  <td>{recipient.Active ? "Ενεργός" : "Ανενεργός"}</td>
                  <td className="text-right">
                    <Button size="sm" color="info" className="mr-2" onClick={() => this.editRecipient(recipient)}>
                      Επεξεργασία
                    </Button>
                    <Button size="sm" color={recipient.Active ? "warning" : "success"} onClick={() => this.toggleRecipientActive(recipient)}>
                      {recipient.Active ? "Απενεργοποίηση" : "Ενεργοποίηση"}
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
          {this.renderPagination(filteredRecipients.length, page, nextPage => this.setState({ recipientPage: nextPage }))}
        </CardBody>
      </Card>
    );
  }

  renderCategoryForm() {
    if (!this.state.showCategoryForm) {
      return null;
    }

    const form = this.state.categoryForm;
    const isEdit = !!form.path;
    const title = isEdit ? "Επεξεργασία κατηγορίας" : "Νέα κατηγορία";
    return (
      <div className="border rounded p-3 mb-4">
        <h4 className="mb-3">{title}</h4>
        <Form onSubmit={e => e.preventDefault()}>
          <Row>
            <Col lg="8">
              <FormGroup>
                <Label>Όνομα κατηγορίας</Label>
                <Input value={form.value} onChange={e => this.updateCategoryField("value", e.target.value)} />
              </FormGroup>
            </Col>
            <Col lg="4">
              <Label check style={{ marginTop: "38px" }}>
                <Input
                  type="checkbox"
                  checked={form.active}
                  onChange={e => this.updateCategoryField("active", e.target.checked)}
                />{" "}
                Ενεργή
              </Label>
            </Col>
          </Row>
          <Button color="primary" className="mr-2" onClick={() => this.saveCategory()}>
            {isEdit ? "Αποθήκευση αλλαγών" : "Δημιουργία κατηγορίας"}
          </Button>
          <Button color="secondary" onClick={() => this.resetCategoryForm()}>
            Ακύρωση
          </Button>
        </Form>
      </div>
    );
  }

  renderCategoryManagement() {
    const action = this.getSelectedCategoryAction();
    const allRows = action ? this.getCategoryRows(action.Target) : [];
    const filteredRows = this.getFilteredCategoryRows(allRows);
    const page = this.getSafePage(this.state.categoryPage, filteredRows.length);
    const rows = this.getPageItems(filteredRows, page);

    return (
      <>
      <br></br>
      <Card>
        <CardHeader>
          <Row className="align-items-center">
            <Col>
              <h3 className="mb-0">Κατηγορίες αιτημάτων</h3>
            </Col>
            <Col className="text-right">
              <Button color="primary" onClick={() => this.showNewCategoryForm()}>
                Προσθήκη κατηγορίας
              </Button>
            </Col>
          </Row>
        </CardHeader>
        <CardBody>
          <h4 className="mb-3">Φίλτρα κατηγοριών</h4>
          <Row className="mb-4">
            <Col lg="4">
              <FormGroup>
                <Label>Ροή αιτήματος</Label>
                <Input
                  type="select"
                  value={this.state.selectedCategoryActionId}
                  onChange={e => this.setState({
                    selectedCategoryActionId: e.target.value,
                    categoryForm: { ...emptyCategory },
                    showCategoryForm: false,
                    categoryPage: 1
                  })}
                >
                  {this.state.categoryActions.map(item => (
                    <option key={item.Id} value={item.Id}>{item.WorkflowName}</option>
                  ))}
                </Input>
              </FormGroup>
            </Col>
            <Col lg="5">
              <FormGroup>
                <Label>Αναζήτηση</Label>
                <Input
                  value={this.state.categorySearch}
                  placeholder="Όνομα κατηγορίας"
                  onChange={e => this.setCategoryFilter("categorySearch", e.target.value)}
                />
              </FormGroup>
            </Col>
            <Col lg="3">
              <FormGroup>
                <Label>Κατάσταση</Label>
                <Input
                  type="select"
                  value={this.state.categoryStatusFilter}
                  onChange={e => this.setCategoryFilter("categoryStatusFilter", e.target.value)}
                >
                  <option value="all">Όλες</option>
                  <option value="active">Ενεργές</option>
                  <option value="inactive">Ανενεργές</option>
                </Input>
              </FormGroup>
            </Col>
          </Row>

          {this.renderCategoryForm()}

          <Table responsive>
            <thead>
              <tr>
                <th>Όνομα κατηγορίας</th>
                <th>Κατάσταση</th>
                <th className="text-right">Ενέργειες</th>
              </tr>
            </thead>
            <tbody>
              {rows.length === 0 &&
                <tr>
                  <td colSpan="3" className="text-center text-muted">Δεν βρέθηκαν κατηγορίες.</td>
                </tr>
              }
              {rows.map(row => (
                <tr key={JSON.stringify(row.path)}>
                  <td>{row.labelPath}</td>
                  <td>{row.node.active === false ? "Ανενεργή" : "Ενεργή"}</td>
                  <td className="text-right">
                    <Button size="sm" color="info" className="mr-2" onClick={() => this.editCategory(row)}>
                      Επεξεργασία
                    </Button>
                    <Button size="sm" color={row.node.active === false ? "success" : "warning"} onClick={() => this.toggleCategoryActive(row)}>
                      {row.node.active === false ? "Ενεργοποίηση" : "Απενεργοποίηση"}
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
          {this.renderPagination(filteredRows.length, page, nextPage => this.setState({ categoryPage: nextPage }))}
        </CardBody>
      </Card>
      </>
    );
  }

  renderResponseDeadlines() {
    return (
      <>
        <br></br>
        <Card>
          <CardHeader>
            <Row className="align-items-center">
              <Col>
                <h3 className="mb-0">Προθεσμίες Απάντησης</h3>
              </Col>
              <Col className="text-right">
                <Button
                  color="primary"
                  onClick={() => this.saveResponseDeadline()}
                  disabled={this.state.responseDeadlineSaving}
                >
                  {this.state.responseDeadlineSaving ? "Αποθήκευση..." : "Αποθήκευση αλλαγών"}
                </Button>
              </Col>
            </Row>
          </CardHeader>
          <CardBody>
            <p className="text-muted mb-4">
              Οι προθεσμίες ορίζονται σε εργάσιμες ημέρες και εφαρμόζονται ανά κατηγορία προϊόντος και τύπο παραλήπτη.
            </p>
            {this.state.responseDeadlineError &&
              <UncontrolledAlert color="danger">{this.state.responseDeadlineError}</UncontrolledAlert>
            }
            {this.state.responseDeadlineMessage &&
              <UncontrolledAlert color="success">{this.state.responseDeadlineMessage}</UncontrolledAlert>
            }
            <Form onSubmit={e => e.preventDefault()}>
              <Row>
                {responseDeadlineFields.map(field => (
                  <Col md="6" key={field.name}>
                    <FormGroup>
                      <Label htmlFor={"response-deadline-" + field.name}>
                        {field.label}
                      </Label>
                      <Input
                        id={"response-deadline-" + field.name}
                        min="1"
                        type="number"
                        value={this.state.responseDeadlines[field.name]}
                        onChange={e => this.updateResponseDeadlineField(field.name, e.target.value)}
                      />
                    </FormGroup>
                  </Col>
                ))}
              </Row>
            </Form>
          </CardBody>
        </Card>
      </>
    );
  }

  render() {
    return (
      <>
        <GenericHeader />
        <Container className="mt--7" fluid>
          {this.state.error &&
            <UncontrolledAlert color="danger">{this.state.error}</UncontrolledAlert>
          }
          {this.state.success &&
            <UncontrolledAlert color="success">{this.state.success}</UncontrolledAlert>
          }
          <Row>
            <Col lg="12">{this.renderRecipients()}</Col>
          </Row>
          <Row>
            <Col lg="12">{this.renderCategoryManagement()}</Col>
          </Row>
          <Row>
            <Col lg="12">{this.renderResponseDeadlines()}</Col>
          </Row>
        </Container>
      </>
    );
  }
}

export default RecipientCategoryManagement;
